export default __webpack_public_path__ + "media/images/preloved_certified.svg";